/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Guild_ExpressionsInputs */



/**
* | output |
* | --- |
* | "Create Expressions" |
*
* @param {Leveling_Perm_Create_Guild_ExpressionsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_guild_expressions = /** @type {((inputs?: Leveling_Perm_Create_Guild_ExpressionsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Guild_ExpressionsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать выражения")
	return /** @type {LocalizedString} */ ("Create Expressions")
});